import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Button } from 'reactstrap';
import styled from 'styled-components';

const ErrorMessage = styled.small`
  color: rgb(242, 108, 79);
  font-size: 0.875rem;
  line-height: 1.2;
  display: block;
  margin-top: 5px;
`;

const InputField = styled.input`
  ${({ error }) =>
    error &&
    `
    border: 1px solid rgb(242, 108, 79) !important;
  `}
`;

const validate = (values) => {
  const errors = {};
  if (!values.currentPassword) {
    errors.currentPassword = 'This field is required';
  }
  if (!values.newPassword) {
    errors.newPassword = 'This field is required';
  } else if (values.newPassword.length < 8) {
    errors.newPassword = 'Must be at least 8 characters';
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = 'This field is required';
  } else if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = 'Passwords do not match';
  }
  return errors;
};

const renderField = ({
  input,
  type,
  placeholder,
  meta: { touched, error },
}) => (
  <div className="form-group">
    <InputField
      {...input}
      type={type}
      placeholder={placeholder}
      className="form-control"
      error={touched && error}
    />
    {touched && error && <ErrorMessage>{error}</ErrorMessage>}
  </div>
);

const PasswordResetForm = (props) => {
  const { handleSubmit, submitting } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="currentPassword"
        component={renderField}
        type="password"
        placeholder="Current Password"
      />
      <Field
        name="newPassword"
        component={renderField}
        type="password"
        placeholder="New Password"
      />
      <Field
        name="confirmPassword"
        component={renderField}
        type="password"
        placeholder="Confirm New Password"
      />
      <Button
        color="primary"
        type="submit"
        disabled={submitting}
        style={{
          opacity: submitting ? 0.6 : 1,
          cursor: submitting ? 'not-allowed' : 'pointer',
        }}
      >
        Update Password
      </Button>
    </form>
  );
};

export default reduxForm({
  form: 'passwordReset',
  validate,
})(PasswordResetForm);
